import React from 'react'
import { useTranslation } from 'react-i18next'
import { InfoOutlined } from '@material-ui/icons'
import { LinkWithText } from 'dls/molecules/Buttons'
import { HelpModalType } from 'store/modal/types'
import { InfoIconButton } from 'dls'
import useModal from 'components/Modal/hooks/useModal'

interface OwnProps {
  textButton?: boolean
}

const UserManagementDialog = ({ textButton = false }: OwnProps) => {
  const { t } = useTranslation()

  const { showInfographicModal } = useModal()

  const cta = textButton ? (
    <LinkWithText
      onClick={() => showInfographicModal(HelpModalType.USERS)}
      endIcon={<InfoOutlined />}
      aria-controls="more-about-dialog"
      aria-haspopup="dialog"
    >
      {t('More about users')}
    </LinkWithText>
  ) : (
    <InfoIconButton
      ariaProps={{
        'aria-label': `${t('More about users')}`,
        'aria-haspopup': 'dialog',
        'aria-controls': 'more-about-dialog',
      }}
      onClick={() => showInfographicModal(HelpModalType.USERS)}
      fontSize="medium"
    />
  )

  return cta
}

export default UserManagementDialog
